// extracted by css-extract-rspack-plugin
export default {"SanitizedHtml":"title-module__SanitizedHtml__eYVjRfs","Link":"title-module__Link__o8eQYO2","SanitizedHtml_1":"title-module__SanitizedHtml_1__VksQXZZ"};